<template>
  <b-card-actions action-collapse title="Clients list">
     <b-row> 
      <b-col md="6">
    
         <b-modal
          id="modal-prevent-closing"
          ref="my-modal"
          title="Add customer"
          ok-title="Submit"
          cancel-variant="outline-secondary"
          @show="resetModal"
          @hidden="resetModal"
          @ok="handleOk"
        >
          <form
            ref="form"
            @submit.stop.prevent="handleSubmit"
          >
         

            <b-form-group
              :state="nameState"
              label="Email"
              label-for="email"
            >
              <b-form-input
                :state="nameState"
                id="email"
                type="email"
                v-model="form.email"
                placeholder="Email"
              />           
            </b-form-group>

              <b-form-group
            :state="nameState"
              label="First name"
              label-for="firstName"
            >
              <b-form-input
                id="firstName"
                placeholder="First name"
                v-model="form.firstName"
                :state="nameState"
              />
            </b-form-group>

            <b-form-group
            :state="nameState"
              label="Last name"
              label-for="lastName"
            >
              <b-form-input
                id="lastName"
                placeholder="Last name"
                v-model="form.lastName"
                :state="nameState"
              />
            </b-form-group>

            <b-form-group
              :state="nameState"
              label="Country"
              label-for="country"
            >
              <b-form-select
                v-model="form.country"
                :options="Paysoptions"
                id="country"
              />
            </b-form-group>
            <b-row>
              <b-col col lg="4">
                <b-form-group
                :state="nameState"
                  label="phonePrefix"
                  label-for="phonePrefix"
                >
                  <b-form-input
                    :state="nameState"
                    id="phonePrefix"
                    type="number"
                    v-model="form.phonePrefix"
                    placeholder="phonePrefix"
                  />
                  </b-form-group>
              </b-col>
              <b-col col lg="8">
                <b-form-group
                :state="nameState"
                  label="Phone"
                  label-for="phoneNumber"
                >
                  <b-form-input
                    :state="nameState"
                    id="phoneNumber"
                    type="number"
                    v-model="form.phoneNumber"
                    placeholder="Phone"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group 
            :state="nameState"
              label="Password"
              label-for="password"
              >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="password"
                  :type="passwordFieldType"
                  placeholder="Password"
                  v-model="form.password"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIcon"
                    class="cursor-pointer"
                    @click="togglePassword"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-form-group 
            :state="nameState"
              label="Confirm password"
              label-for="passwordRetype"
              >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="passwordRetype"
                  v-model="form.passwordRetype"
                  :type="passwordFieldTypeRetype"
                  placeholder="Confirm password"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIconRetype"
                    class="cursor-pointer"
                    @click="togglePasswordRetype"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>


            <b-form-group
            :state="nameState"
              label="Tax registration number"
              label-for="taxRegistrationNumber"
            >
              <b-form-input
                :state="nameState"
                id="taxRegistrationNumber"
                type="number"
                v-model="form.taxRegistrationNumber"
                placeholder="Tax registration number"
              />
            </b-form-group>
            
          </form>  
        </b-modal> 
      </b-col>
      <b-col>
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
            <!-- <b-button
              variant="gradient-danger"
              class="btn-icon btn-delete-all"
              @click="deleteAllclients()"
            >
              <feather-icon icon="TrashIcon" />
            </b-button> -->
              <b-button
                variant="gradient-primary"
              class="btn-icon btn-delete-all"
                v-b-modal.modal-prevent-closing
              >
                <feather-icon
                  icon="PlusCircleIcon"
                />
              </b-button>
            <!-- <download-excel
              :data="json_data"
              name="clients.xls"
              :fields="json_fields"
              class="btn-delete-all"
            >
            </download-excel> -->
          </div>
        </b-form-group>
      </div>
    </div>
    </b-col>
    </b-row>  
    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-client"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>

              <b-dropdown-item @click="selectQuote(props.row.user._id)">
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/sale/quotations?id=${props.row.user._id}`">Quotations</router-link></span>
              </b-dropdown-item>

              <b-dropdown-item @click="selectInstantQuote(props.row.user._id)">
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/instant-estimation?id=${props.row.user._id}`">Instant Estimate</router-link></span>
              </b-dropdown-item>

              <b-dropdown-item @click="selectBooking(props.row.user._id)">
              <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/sale/quotations/booking?id=${props.row.user._id}`">Bookings</router-link></span>
              </b-dropdown-item>

              <b-dropdown-item @click="selectBL(props.row.user._id)">
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/bl?id=${props.row.user._id}`">BLs</router-link></span>
              </b-dropdown-item>

              <b-dropdown-item @click="UpdateClient(props.row._id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span><router-link :to="`/customers/edit?id=${props.row._id}`">Update informations</router-link></span>
              </b-dropdown-item>

              <b-dropdown-item @click="DeleteClient(props.row.user._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete account</span>
              </b-dropdown-item>
              
            </b-dropdown>
          </span>
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-actions>
</template>

<script>
import VueBarcode from "vue-barcode";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BInputGroupAppend,
  BInputGroup,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    BDropdown,
    BDropdownItem,
    BTooltip,
    VueBarcode,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BInputGroupAppend,
    BInputGroup,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      json_data: [],
      json_fields: {
        company: "company",
        "first Name": "firstName",
        "Last Name": "lastName",
        Email: "email",
        Cite: "city",
        Phone: "phoneNumber",
        "tax Registration Number": "taxRegistrationNumber",
      },
      pageLength: 5,
      dir: false,
      columns: [
         {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "First Name",
          field: "firstName",
          filterOptions: {
            enabled: true,
            placeholder: "First Name",
          },
        },
        {
          label: "Last Name",
          field: "lastName",
          filterOptions: {
            enabled: true,
            placeholder: "Last Name",
          },
        },
        {
          label: "Email ",
          field: "user.email",
          filterOptions: {
            enabled: true,
            placeholder: "Email",
          },
        },
        {
          label: "Company",
          field: "company",
          filterOptions: {
            enabled: true,
            placeholder: "Company",
          },
        },
        {
          label: "Country",
          field: "country",
          filterOptions: {
            enabled: true,
            placeholder: "Country",
          },
        },
         {
          label: "City",
          field: "city",
          filterOptions: {
            enabled: true,
            placeholder: "City ",
          },
        },
         {
          label: "Phone Number",
          field: "phoneNumber",
          filterOptions: {
            enabled: true,
            placeholder: "Phone Number",
          },
        },
          {
          label: "Tax Registration Number",
          field: "taxRegistrationNumber",
          filterOptions: {
            enabled: true,
            placeholder: "Tax Registration Number",
          },
        },
        
        
      ],
      rows: [],
      searchTerm: "",
      form: {
        email: '',
        firstName: '',
        lastName: '',
        country: null,
        phoneNumber: '',
        phonePrefix: '',
        password: '',
        retypePassword: '',
        taxRegistrationNumber: '',
         role: "customer",
      },
      nameState: null,
      submittedData: {
        email: String,
        firstName: String,
        lastName: String,
        country: String,
        phoneNumber: String,
        phonePrefix: String,
        password: String,
        passwordRetype: String,
        taxRegistrationNumber: String,
        role: "customer",
      },
      Paysoptions: [
        { value: null, text: 'Please select an option' },
        { value: 'Tunis', text: 'Tunis' },
        { value: 'France', text: 'France' },
        { value: 'Egypt', text: 'Egypt' },
        { value: 'Allemagne', text: 'Allemagne' },
        { value: 'Maroc', text: 'Maroc' },
      ],
      passwordFieldType: "password",
      passwordFieldTypeRetype: "password",
    };
  },
  async created() {
    await this.getAllDataClient();
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
     passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    async getAllDataClient() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/customers"
      );
      this.rows = response.data.data;
      this.json_data = response.data.data;
      console.log("clients",this.rows);
    },
    DeleteClient(id) {
      this.$swal({
        title: "you really want to delete this client ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm !",
        cancelButtonText: "Decline !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios
            .delete(
            "https://mtl-feeder-nodejs.onrender.com/api/users/"+id
            )
            .then((response) => {
              this.getAllDataClient();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `client deleted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    UpdateClient(id) {
      var routerLink = "/customers/edit?id=" + id;
      this.$router.replace(routerLink);
    },
    selectQuote(id) {
       var routerLink = "/sale/quotations?id=" + id;
      this.$router.replace(routerLink);
    },
    selectInstantQuote(id) {
       var routerLink = "/instant-estimation?id=" + id;
      this.$router.replace(routerLink);
    },
    selectBooking(id) {
       var routerLink = "/sale/quotations/booking?id=" + id;
      this.$router.replace(routerLink);
    },
    selectBL(id) {
      var routerLink = "/bl?id=" + id;
      this.$router.replace(routerLink);
    },
    advanceSearch(val) {
      this.searchTerm = val;
    },
    dateFormat: function (value) {
      return new Date(value).toLocaleString();
    },
    // name agent de saisie
    nameFormat: function (value) {
      return value.firstName + " " + value.lastName;
    },
     checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.firstName = '';
      this.nameState = null;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the link to submitted Data
      //this.submittedData.push(this.form.firstName);
      this.submittedData = this.form;

      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      });
  console.log(this.submittedData);
      axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/users",this.submittedData
        )
        .then((response) => {
          console.log(response);
          this.getAllDataClient()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Membre added",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during add",
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
        });
    },
    togglePassword() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype =
        this.passwordFieldTypeRetype === "password" ? "text" : "password";
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style>
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}

.btn-delete-all {
  margin-left: 3%;
}
</style>
